export default __webpack_public_path__ + "static/media/rs.2f72ed45.svg";